import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { Availability, } from "../../ordering";
import { toPairs } from "../../core";
import { ErrorBox, SelectableFieldController, TextFieldController, } from "../../form";
export class FulfillmentTimeController {
    constructor(params) {
        var _a, _b;
        this.purchaseOrderFulfillmentTime = params.purchaseOrderFulfillmentTime;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.fulfillmentTime = params.fulfillmentTime;
        this.fulfillmentHour = new SelectableFieldController({
            initialValue: (_a = this.fulfillmentTime.hourValue) !== null && _a !== void 0 ? _a : "",
            onUpdate: (value) => this.fulfillmentTime.setHour(value),
            errorBox: new ErrorBox({
                domainObjects: [this.purchaseOrderFulfillmentTime],
                errorMessages: {
                    FulfillmentTimesEmpty: I18n.t("_common.form.errors.required"),
                    FulfillmentTimeOutOfRange: I18n.t("_common.form.errors.invalid"),
                },
            }),
        });
        this.fulfillmentDate = new TextFieldController({
            initialValue: (_b = this.fulfillmentTime.dateValue) !== null && _b !== void 0 ? _b : "",
            onUpdate: (value) => this.fulfillmentTime.setDate(value, this.fulfillmentHour),
            errorBox: new ErrorBox({
                domainObjects: [
                    this.fulfillmentInstructions,
                    this.purchaseOrderFulfillmentTime,
                ],
                errorMessages: {
                    InvalidDate: I18n.t("_common.form.errors.invalid"),
                    FulfillmentDatesEmpty: I18n.t("_common.form.errors.invalid"),
                    FulfillmentDateOutOfRange: I18n.t("_common.form.errors.invalid"),
                },
            }),
        });
        this.fulfillmentOption = new SelectableFieldController({
            initialValue: this.fulfillmentTime.optionValue,
            onUpdate: (value) => {
                this.fulfillmentTime.setOption(value, this.fulfillmentDate, this.fulfillmentHour);
            },
            options: ["ASAP", "Today", "InFuture"],
            errorBox: new ErrorBox({
                domainObjects: [this.fulfillmentInstructions],
                errorMessages: {
                    FulfillmentTimeMissing: I18n.t("_common.form.errors.required"),
                },
            }),
        });
        makeAutoObservable(this);
    }
    get fields() {
        return {
            fulfillmentOption: this.fulfillmentOption,
            fulfillmentDate: this.fulfillmentDate,
            fulfillmentHour: this.fulfillmentHour,
        };
    }
    get fieldsArray() {
        return toPairs(this.fields).map(([_, field]) => field);
    }
    get isDirty() {
        return this.fieldsArray.some((field) => field.isDirty);
    }
    get isTouched() {
        return this.fieldsArray.some((field) => field.isTouched);
    }
    get isInvalid() {
        const controllerAvailability = Availability.composite([
            Availability.boolean({
                FieldsInvalid: this.fieldsArray.some((field) => field.isInvalid),
            }),
            this.fulfillmentInstructions.fulfillmentTimeAvailability,
            this.purchaseOrderFulfillmentTime.availability,
        ]);
        return controllerAvailability.isAvailable.isDefinitelyFalse;
    }
    get isValid() {
        return !this.isInvalid;
    }
    get domain() {
        return this.fulfillmentInstructions;
    }
    submit() {
        this.fieldsArray.forEach((field) => field.blur());
    }
}
